import React, { useEffect } from "react";
import { Box, Button, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextFields from "../../../Component/form/TextFields";
import PhoneNumberField from "../../../helper/Form/PhoneNumber";

const validationSchema = yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  email: yup
    .string()
    .required("Email is required")
    .email("Enter a valid email address"),
  phoneNumber: yup.string().required("Phone number is required"),
  // .matches(/^[0-9]+$/, "Phone number must contain only digits"),
});

export default function ApplicantDetails({
  handleNext,
  getValues,
  setGetValues,
}) {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      fullName: getValues?.applicant?.fullName || "",
      email: getValues?.applicant?.email || "",
      phoneNumber: getValues?.applicant?.phoneNumber || "",
    },
  });

  useEffect(() => {
    if (getValues) {
      setValue("fullName", getValues.applicant?.fullName || "");
      setValue("email", getValues.applicant?.email || "");
      setValue("phoneNumber", getValues.applicant?.phoneNumber || "");
    }
  }, [getValues, setValue]);

  const onSubmit = (data) => {
    setGetValues((prevData) => ({
      ...prevData,
      applicant: data,
    }));
    handleNext();
  };

  return (
    <Box sx={{ mx: "auto", maxWidth: 800 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <TextFields
              control={control}
              name="fullName"
              label="Full Name"
              placeholder="Enter your full name"
              error={errors.fullName}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFields
              control={control}
              name="email"
              label="Email"
              placeholder="Enter your email"
              error={errors.email}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <PhoneNumberField
              control={control}
              name="phoneNumber"
              label="Phone Number"
              error={errors.phoneNumber}
              required
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button variant="contained" type="submit" sx={{textTransform:"none"}}>
            Next
          </Button>
        </Box>
      </form>
    </Box>
  );
}
